<template>
	<section>
		<el-tabs v-model="activeName" type="card">
			<!--open list-->
			<el-tab-pane label="Active" name="first">
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="filters">
						<el-form-item>
							<el-input v-model="filters.openOfferFilter" placeholder="Product Name or UPC" @keyup.enter.native="getOpenOffers" clearable>
								<el-button slot="append" icon="el-icon-search" @click="getOpenOffers"></el-button>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="exportExcel('/excel/exportNurseActiveOffer','activeOffer.xls')">Export</el-button>
						</el-form-item>
					</el-form>
				</el-col>

				<!--列表-->
				<el-table stripe :data="openOffers" highlight-current-row v-loading="firstListLoading" style="width: 100%;">
					<el-table-column label="#" prop="offerNo" width="80px">
					</el-table-column>
					<el-table-column label="Offer" width="300px">
						<template slot-scope="scope">
							{{scope.row.productName}}
							<div class="note" v-html="scope.row.note"></div>
						</template>
					</el-table-column>
					<el-table-column prop="createBy" label="Company"  >
					</el-table-column>
					<el-table-column prop="price" label="Price"  >
					</el-table-column>
					<el-table-column prop="bouns" label="Bouns"  >
					</el-table-column>
					<el-table-column prop="leftNum" label="Qty"  >
					</el-table-column>
                    <el-table-column prop="status" label="Status" >
                        <template slot-scope="scope">
                            <p v-if="scope.row.leftNum>0"><el-tag>Can Take</el-tag></p>
                            <p v-if="scope.row.leftNum<=0"><el-tag type="danger">No surplus</el-tag></p>
                        </template>
                    </el-table-column>
					<el-table-column prop="createDate" label="Create Date"  :formatter="formatTimesTamp">
					</el-table-column>
					<el-table-column label="Action">
						<template slot-scope="scope">
							<el-button size="small" @click="showTakeOffer(scope.row.offerNo)">Take</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="prev, pager, next" @current-change="changeOfferPage" :page-size="pageSize" :total="openOfferTotal" style="float:right;">
					</el-pagination>
				</el-col>
			</el-tab-pane>
			<!--proposed offer list-->
			<el-tab-pane label="Proposed" name="second">
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="filters">
						<el-form-item>
							<el-input v-model="filters.proposedFilter" placeholder="Product Name or UPC" clearable @keyup.enter.native="getProposedOffers">
								<el-button slot="append" icon="el-icon-search" @click="getProposedOffers"></el-button>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" v-on:click="showProposed">Request</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="exportExcel('/excel/exportNurseProposedOffer','proposedOffer.xls')">Export</el-button>
						</el-form-item>

					</el-form>
				</el-col>

				<!--列表-->
				<el-table stripe :data="proposedOffers" highlight-current-row v-loading="secondListLoading" style="width: 100%;">
					<el-table-column type="index">
					</el-table-column>
					<el-table-column prop="productName" label="Offer"  >
					</el-table-column>
					<el-table-column prop="company" label="Company"  >
					</el-table-column>
					<el-table-column prop="price" label="Price"  >
					</el-table-column>
					<el-table-column prop="quantity" label="Qty"  >
					</el-table-column>
					<el-table-column prop="createDate" label="Create Date"  >
					</el-table-column>
					<el-table-column label="Status">
						<template slot-scope="scope">
							<p v-if="scope.row.status===0"><el-tag type="info">Pending</el-tag></p>
							<p v-if="scope.row.status===1"><el-tag type="success">Confirmed</el-tag></p>
							<p v-if="scope.row.status===2"><el-tag type="danger">Rejected</el-tag></p>
							<p v-if="scope.row.status===3"><el-tag type="danger">cancelled</el-tag></p>
						</template>
					</el-table-column>
					<el-table-column label="Action">
						<template slot-scope="scope" v-if="scope.row.status===0">
								<el-button @click="cancelProposed(scope.row.id,2)" size="small" type="danger">Cancel</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="prev, pager, next" @current-change="changeProposedPage" :page-size="pageSize" :total="proposedTotal" style="float:right;">
					</el-pagination>
				</el-col>
			</el-tab-pane>

			<!--expired list-->
			<el-tab-pane label="Expired" name="fourth">
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="filters">
						<el-form-item>
							<el-input v-model="filters.expiredFilter" placeholder="Product Name or UPC" @keyup.enter.native="getExpiredOffers" clearable>
								<el-button slot="append" icon="el-icon-search" @click="getExpiredOffers"></el-button>
							</el-input>
						</el-form-item>
						<!--<el-form-item>-->
							<!--<el-button type="primary" @click="exportExcel('/excel/exportNurseActiveOffer','activeOffer.xls')">Export</el-button>-->
						<!--</el-form-item>-->
					</el-form>
				</el-col>

				<!--列表-->
				<el-table stripe :data="expiredList" highlight-current-row v-loading="fourthListLoading" style="width: 100%;">
					<el-table-column label="#" prop="offerNo" width="80px">
					</el-table-column>
					<el-table-column label="Offer" width="300px">
						<template slot-scope="scope">
							{{scope.row.productName}}
							<div class="note" v-html="scope.row.note"></div>
						</template>
					</el-table-column>
					<el-table-column prop="createBy" label="Company"  >
					</el-table-column>
					<el-table-column prop="price" label="Price"  >
					</el-table-column>
					<el-table-column prop="bouns" label="Bouns"  >
					</el-table-column>
					<el-table-column prop="leftNum" label="Qty"  >
					</el-table-column>
					<el-table-column prop="createDate" label="Create Date"  :formatter="formatTimesTamp">
					</el-table-column>
					<el-table-column label="Action">
						<template slot-scope="scope">
							<el-button size="small" @click="showProposedOffer(scope.row.offerNo)">Propose</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="prev, pager, next" @current-change="changeExpiredPage" :page-size="pageSize" :total="expiredTotal" style="float:right;">
					</el-pagination>
				</el-col>
			</el-tab-pane>

			<!--offer history list-->
			<el-tab-pane label="Offer History" name="third">
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="filters">
						<el-form-item>
							<el-input v-model="filters.historyFilter" placeholder="Product Name or UPC" @keyup.enter.native="getOfferHistroy">
								<el-button slot="append" icon="el-icon-search" @click="getOfferHistroy"></el-button>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-select v-model="filters.historyStatus" placeholder="Status" @change="getOfferHistroy" clearable>
								<el-option label="Pending" value="0" ></el-option>
								<el-option label="Completed" value="1" ></el-option>
								<el-option label="Canceled" value="2" ></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="exportExcel('/excel/exportNurseOfferHistory','offerHistory.xls')">Export</el-button>
						</el-form-item>
					</el-form>
				</el-col>

				<!--列表-->
				<el-table stripe :data="historyList" highlight-current-row v-loading="thirdListLoading" style="width: 100%;">
					<el-table-column prop="offerNo" label="#">
					</el-table-column>
					<el-table-column prop="productName" label="Offer"  >
					</el-table-column>
					<el-table-column prop="doctor" label="Company"  >
					</el-table-column>
					<el-table-column prop="price" label="Price"  >
					</el-table-column>
					<el-table-column prop="quantity" label="Qty"  >
					</el-table-column>
					<el-table-column label="Warehouse" >
						<template slot-scope="scope">
							<p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
							<p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="offerCreateTime" label="Offer Create Date"  >
					</el-table-column>
					<el-table-column prop="takeDate" label="Take Date"  >
					</el-table-column>
					<el-table-column label="Status">
						<template slot-scope="scope">
							<p v-if="scope.row.status===0"><el-tag type="info">Confirmed</el-tag></p>
							<p v-if="scope.row.status===1"><el-tag type="success">Completed</el-tag></p>
							<p v-if="scope.row.status===2"><el-tag type="danger">Canceled</el-tag></p>
						</template>
					</el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
					</el-pagination>
				</el-col>
			</el-tab-pane>
		</el-tabs>

		<!--新增界面-->
		<el-dialog title="Take Offer" width="80%" :visible.sync="takeOfferVisible" :close-on-click-modal="false">
			<el-form :model="takeOffer" label-width="220px" :rules="formRules" ref="takeOffer">
				<el-form-item label="company" prop="Company">
					<el-input v-model="takeOffer.createBy" :disabled="true" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="Product" prop="product">
					<el-input v-model="takeOffer.product" :disabled="true" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="Price">
					<el-input-number v-model="takeOffer.price" :disabled="true" :min="0"></el-input-number>
				</el-form-item>
                <el-form-item label="Bonus">
                    <el-input-number v-model="takeOffer.bouns" :min="0" :disabled="true"></el-input-number>
                </el-form-item>
				<el-form-item label="Left" prop="leftNum">
					<el-input-number v-model.number="takeOffer.leftNum" :disabled="true"></el-input-number>
				</el-form-item>
				<el-form-item label="Quantity" prop="quantity">
					<el-input-number v-model.number="takeOffer.quantity" :min="0"></el-input-number>
				</el-form-item>
				<el-form-item label="Warehouse" prop="warehouseNo" >
					<el-select v-model="takeOffer.warehouseNo" type="textarea" rows="5" clearable auto-complete="off">
						<el-option-group v-for="group in warehouses" :key="group.label" :label="group.label">
							<el-option v-for="(item,index) in group.options" :key="index" :label="item.state+' '+item.city +' '+item.address" :value="item.warehouseNo">
							</el-option>
						</el-option-group>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="takeOfferVisible = false">Close</el-button>
				<el-button type="primary" @click.native="handleTakeOffer" :loading="loading">Submit</el-button>
			</div>
		</el-dialog>

		<el-dialog title="Proposed offer" width="80%" :visible.sync="proposedOfferVisible" :close-on-click-modal="false">
			<el-form :model="proposedOffer" label-width="220px" :rules="proposedFormRules" ref="proposedOffer">
				<el-form-item label="Product" prop="offerNo">
					<el-select v-model="proposedOffer.offerNo" auto-complete="off" @change="selectProposedOffer" clearable disabled >
                        <el-option v-for="(item,index) in proposedList" :key="index" :label="item.productName + ' ('+item.createDate+')'" :value="item.offerNo"></el-option>
					</el-select>
				</el-form-item>
				<div v-if="proposedOffer.offerNo">
					<el-form-item label="company" prop="createBy">
						<el-input v-model="proposedOffer.createBy" :disabled="true" auto-complete="off">
						</el-input>
					</el-form-item>
					<el-form-item label="Price" prop="price">
						<el-input-number v-model="proposedOffer.price" :disabled="true" :min="0"></el-input-number>
					</el-form-item>
					<el-form-item label="Quantity" prop="quantity">
						<el-input-number v-model="proposedOffer.quantity" :min="0"></el-input-number>
					</el-form-item>
					<el-form-item label="Warehouse" prop="warehouseNo" >
						<el-select v-model="proposedOffer.warehouseNo" type="textarea" rows="5" clearable auto-complete="off">
							<el-option-group v-for="group in warehouses" :key="group.label" :label="group.label">
								<el-option v-for="(item,index) in group.options" :key="index" :label="item.state+' '+item.city +' '+item.address" :value="item.warehouseNo">
								</el-option>
							</el-option-group>
						</el-select>
					</el-form-item>
				</div>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="proposedOfferVisible = false">Close</el-button>
				<el-button type="primary" @click.native="requestProposed" :loading="loading">Submit</el-button>
			</div>
		</el-dialog>
	</section>
</template>


<script>
	import util from '../../common/js/util'
	import {defaultPageSize} from "../../globalVar";
    import { removeProposedOffer,getOpenOffers,getProposedOffers,getNurseOffer,getOfferById,takeOffer,requestProposedOffers,getProposedOfferList,getNurseOfferHistoryList,expiredOffers} from '../../api/offerService';
    import {getNurseWarehouses} from "../../api/warehouseService";
	import {postExportExcel} from "../../api/exportService";
    import ElOption from "element-ui/packages/select/src/option";
    import ElButton from "element-ui/packages/button/src/button";

    export default {
        components: {
            ElButton,
            ElOption},
        props: {
            'current-company':String
		},
        created(){
            this.$on('changeDoctor',(value) => {
                setTimeout(()=>{
                    this.getOpenOffers();
                    this.getWarehouse();
                    this.getProposedOffers();
                    this.getOfferHistroy();
				},300);
            });
        },
		data() {
			return {
                loading:false,
			    company:this.currentCompany,
				warehouses:[],
				options: [{
					label: 'Self Category',
					options: [{
						value: '1',
						label: 'FL 0001'
					}]
				}, {
					label: 'Warehouse',
					options: [{
						value: '2',
						label: 'FL 0002'
					}]
				}],

				pageSize:defaultPageSize,
				openOfferPage:1,
				openOfferTotal:0,

				proposedPage:1,
				proposedTotal:0,

				historyPage:1,
				historyTotal:0,

				expiredPage:1,
				expiredTotal:0,

				activeName:"first",
				filters: {
                	historyStatus:"",
                	historyFilter:"",
                    proposedFilter:"",
			        openOfferFilter:"",
					expiredFilter:"",
					name: ''
				},

				proposedList:[],

				historyList:[],

				openOffers: [],
				proposedOffers: [],

				expiredList:[],
				total: 0,
				page: 1,

				firstListLoading:false,
				secondListLoading:false,
				thirdListLoading:false,
				fourthListLoading:false,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
                    warehouseNo: [
						{ required: true, message: 'Warehouse is required.', trigger: 'blur' }
					],
                    quantity: [
                        { required: true, message: 'Quantity is required.', trigger: 'blur' },
                        { validator: this.checkQuantity, trigger: 'blur' }
                    ]
				},
				//编辑界面数据
				editForm: {
					id: 0,
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				},

				takeOfferVisible: false,//新增界面是否显示
				proposedOfferVisible:false,
				addLoading: false,
                proposedFormRules: {
                    warehouseNo: [
                        { required: true, message: 'Warehouse is required.', trigger: 'blur' }
                    ],
                    quantity: [
                        { required: true, message: 'Quantity is required.', trigger: 'blur' },
                        { validator: this.checkProposedQuantity, trigger: 'blur' }
                    ]
				},
				//新增界面数据
				takeOffer: {
					createBy:"",
					price:"",
					quantity:0,
					product:"",
                    warehouseNo:""
				},
				proposedOffer:{
					offer:"",
					createBy:"",
					price:"",
					quantity:"",
					product:"",
					warehouseNo:"",
                    offerNo:""
				}
			}
		},
		methods: {
            cancelProposed(id,status){
                this.$confirm('Are you sure?', 'Warning', {
                    type: 'warning'
                }).then(() => {
                    removeProposedOffer({id:id}).then((res)=>{
                        if(res.status===200){
                            this.$message.success(res.message);
                            this.getProposedOffers();
                        }else{
                            this.$message.error(res.message);
							this.getProposedOffers();
                        }
                    })
                }).catch(() => {

                });
            },
			exportExcel(url,fileName,type){
				let param = {
					url:url,
					fileName:fileName,
					doctorNo:window.sessionStorage.getItem("currentCompany")
				}
				postExportExcel(param).then(function(){

				})
			},
        	getOfferHistroy(){
        		let param = {
					current:this.historyPage,
					size:this.pageSize,
					doctorNo:window.sessionStorage.getItem("currentCompany"),
					condition:this.filters.historyFilter,
					status:this.filters.historyStatus
				}
				this.thirdListLoading = true;
        		getNurseOfferHistoryList(param).then((data)=>{
					this.thirdListLoading = false;
					if(data.status===200){
						this.historyList = data.result.records;
						this.historyTotal = data.result.total;
					}
				})

			},
            getExpiredOffers(){
                let param = {
                    current:this.expiredPage,
                    size:this.pageSize,
                    doctorNo:window.sessionStorage.getItem("currentCompany"),
                    condition:this.filters.expiredFilter
                }
                this.fourthListLoading = true;
                expiredOffers(param).then((data)=>{
                    this.fourthListLoading = false;
                    if(data.status===200){
                        this.expiredList = data.result.records;
                        this.expiredTotal = data.result.total;
                    }
                })

            },
            selectProposedOffer(val){
                let selected = this.proposedList.filter((item)=>{
                    return item.offerNo===val;
                });
                if(selected&&selected.length===1){
                    this.proposedOffer.createBy = selected[0].createBy;
                    this.proposedOffer.price = selected[0].price;
                }
            },
            showProposed(){
                this.getProposedOfferList().then(()=>{
                    this.proposedOfferVisible = true;
				})
			},
            getProposedOfferList(){
                let param = {
                    doctorNo:window.sessionStorage.getItem("currentCompany")
                }
                return getProposedOfferList(param).then((data)=>{
                    if(data.status===200){
						this.proposedList = data.result;
                    }
                })
            },
            formatProposedStatus(row,column){
                if(row.status===0){
                    return "Pending";
                }else if(row.status===1){
                    return "Confirmed";
                }else {
                    return "Rejected"
                }
			},
            requestProposed(){
                this.$refs.proposedOffer.validate((valid)=>{
                    if(valid){
                        this.loading = true;
                        let param = {
							doctorNo:window.sessionStorage.getItem("currentCompany"),
							offerNo:this.proposedOffer.offerNo,
                            warehouseNo:this.proposedOffer.warehouseNo,
							quantity:this.proposedOffer.quantity,

                        };
                        requestProposedOffers(param).then((data)=>{
                            this.loading = false;
							if(data.status===200){
							    this.proposedOfferVisible = false;
							    this.$message.success(data.message);
                                this.$refs.proposedOffer.resetFields();
							    this.getProposedOffers();
							    this.getOpenOffers();
							}else{
							    this.$message.error(data.message);
							}
                        })
					}
				})

			},
            changeOfferPage(val){
                this.openOfferPage = val;
                this.getOpenOffers();
			},
            changeProposedPage(val){
                this.proposedPage = val;
                this.getProposedOffers();
            },
			changeHistoryPage(val){
				this.historyPage = val;
				this.getOfferHistroy();
			},
            changeExpiredPage(val){
                this.expiredPage = val;
                this.getExpiredOffers();
            },
            checkQuantity(rule, value, callback) {
                if (!value>0) {
                    return callback(new Error('Quantity must more than 1.'));
                }else if(value>this.takeOffer.leftNum){
                    return callback(new Error("Quantity can't more than left."));
				}else{
                    callback();
				}
			},
            checkProposedQuantity(rule, value, callback) {
                if (!value>0) {
                    return callback(new Error('Quantity must more than 1.'));
                }else{
                    callback();
                }
            },
            formatTimesTamp(row, column){
                return util.formatDate.format(new Date(row.createDate),'yyyy-MM-dd hh:mm:ss');
            },
            getWarehouse(){
                let param = {
                    doctorNo:window.sessionStorage.getItem("currentCompany")
				};
				getNurseWarehouses(param).then((res)=>{
				    if(res.status===200){
                        this.warehouses = [];
				        let self = {
                            label: 'Self Storage',
                            options: []
						};
				        let doctors = {
                            label: 'Warehouse',
                            options: []
						};
				        res.result.forEach((item)=>{
				            if(item.isDoctor===0){
                                doctors.options.push(item)
							}else{
                                self.options.push(item)
							}
						});
						if(self.options.length>0){
						    this.warehouses.push(self);
						}
						if(doctors.options.length>0){
						    this.warehouses.push(doctors)
						}
					}
				})
			},
			changeProposedOffer(){
				this.proposedOffer.product = this.proposedOffer.offer.product;
				this.proposedOffer.price = this.proposedOffer.offer.price;
				this.proposedOffer.createBy = this.proposedOffer.offer.createBy;
			},
			showTakeOffer(offerId){
                getOfferById({offerNo:offerId}).then((res)=>{
                    if(res.status===200){
                        if(res.result.offer.leftNum>0){
                            this.takeOffer.offerNo = res.result.offer.offerNo;
                            this.takeOffer.product = res.result.productName;
                            this.takeOffer.price = res.result.offer.price;
                            this.takeOffer.leftNum = res.result.offer.leftNum;
                            this.takeOffer.bouns = res.result.offer.bouns;
                            this.takeOffer.createBy = res.result.doctorName;
                            this.takeOfferVisible = true;
						}else{
                            this.$confirm("Offer quantity is take over, do you want to request a proposed?","Warning",{
                                type:"warning"
                            }).then(()=>{
                                return this.getProposedOfferList();
							}).then(()=>{
                                this.proposedOfferVisible = true;
                                this.proposedOffer.productName = res.result.productName;
                                this.proposedOffer.createBy = res.result.doctorName;
                                this.proposedOffer.price = res.result.offer.price;
                                this.proposedOffer.offerNo = res.result.offer.offerNo;
							}).catch(()=>{})
						}

                    }
                });
			},
			showProposedOffer(offerId){
                this.getProposedOfferList().then(()=>{
                    return getOfferById({offerNo:offerId})
				}).then((res)=>{
                    if(res.status===200){
						this.proposedOfferVisible = true;
						this.proposedOffer.productName = res.result.productName;
						this.proposedOffer.createBy = res.result.doctorName;
						this.proposedOffer.price = res.result.offer.price;
						this.proposedOffer.offerNo = res.result.offer.offerNo;
                    }
                });
			},
			handleTakeOffer(){
				let param = {
                    offerNo:this.takeOffer.offerNo,
                    warehouseNo:this.takeOffer.warehouseNo,
                    quantity:this.takeOffer.quantity,
                    doctorNo:window.sessionStorage.getItem("currentCompany")
				};
				this.$refs.takeOffer.validate((valid)=>{
				    if(valid){
                        this.loading = true;
                        takeOffer(param).then((res)=>{
                            this.loading = false;
                            if(res.status===200){
                                this.$message.success(res.message);
                                this.takeOfferVisible = false;
                                this.$refs.takeOffer.resetFields();
                                this.getOpenOffers();
                                this.getOfferHistroy();
                            }else{
                                this.$message.error(res.message);
                            }
                        })
					}
				});
			},
			handleCurrentChange(val) {
				this.page = val;
				//this.getUsers();
			},
			//获取用户列表
			getOpenOffers() {
				let param = {
					current: this.openOfferPage,
					size:this.pageSize,
					condition: this.filters.openOfferFilter,
					doctorNo:window.sessionStorage.getItem("currentCompany")
				};
				this.firstListLoading = true;
                getNurseOffer(param).then((res) => {
                    this.firstListLoading = false;
					this.openOffers = res.result.records;
					this.openOfferTotal = res.result.total;
				});
			},
			getProposedOffers(){
                let param = {
                    current:this.proposedPage,
					size:this.pageSize,
					condition:this.filters.proposedFilter,
					doctorNo:window.sessionStorage.getItem("currentCompany")
				}
				this.secondListLoading = true;
				getProposedOffers(param).then((data)=>{
                    this.secondListLoading = false;
                    if(data.status===200){
                        this.proposedOffers = data.result.records;
                        this.proposedTotal = data.result.total;
					}
				})
			}
		},
		mounted() {
			this.getOpenOffers();
			this.getProposedOffers();
			this.getWarehouse();
			this.getOfferHistroy();
			this.getExpiredOffers();
			let active = this.$route.params.active;
			if(active){
				this.activeName = active;
			}
		}
	}

</script>


// WEBPACK FOOTER //
// offer.vue?bcc63e48